import { render, staticRenderFns } from "./venueAppointment-content-item.vue?vue&type=template&id=277c253f&scoped=true"
import script from "./venueAppointment-content-item.vue?vue&type=script&lang=js"
export * from "./venueAppointment-content-item.vue?vue&type=script&lang=js"
import style0 from "./venueAppointment-content-item.vue?vue&type=style&index=0&id=277c253f&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "277c253f",
  null
  
)

export default component.exports